// src/plugin.ts
var fallbackPlugin = () => {
  const getModule = (from) => {
    if (from === "build") {
      return () => ({
        __esModule: true,
        default: { isFallbackModule: true }
      });
    } else {
      return {
        default: { isFallbackModule: true }
      };
    }
  };
  return {
    name: "fallback-plugin",
    errorLoadRemote({ id, from }) {
      console.error(id, "offline");
      return getModule(from);
    }
  };
};
var plugin_default = fallbackPlugin;
export {
  plugin_default as default
};
//# sourceMappingURL=plugin.mjs.map